export {decorateDateString} from "../../utils/decorateDateString";
import {getImagesForPost} from "../../post/getImagesForPost.js";
import {addImpression} from "../../utils/addImpression.js";

export function populateImagesBox(entry, container, timelineElement) {
    container.addClass("images");
    var clonedBox = $(".images_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("images_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("images_box");
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find("input[type=\"hidden\"][name=\"post_id\"]").val(entry.id);
    clonedBox.find(".prost_count").text(entry.sum_prosts);
    clonedBox.find(".comment_count").text(entry.sum_comments);
    clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
    let $html = $('<div>').html(entry.content);
    let $imgs = $html.find('img');
    $imgs.remove();
    $imageContainer= clonedBox.find('.js-image-gallery');
   let commentContent = $html.html();
    if ($imgs.length > 0) {
        $imgs.each(function () {
            let $wrapped = $('<div></div>').append($(this).clone());
            $imageContainer.append($wrapped);
        });
    }


    clonedBox.find(".js-author-comment").html(commentContent);
    getImagesForPost(entry.type, timelineElement);



    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}